// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ServiceMessagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ServiceMessagesQuery = { paginateServiceMessages?: { total?: unknown, items?: Array<{ id?: string, title?: string, content?: string, published: boolean, publishDate?: string, unPublishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, location?: Array<Types.ServiceMessageLocation>, application?: Types.ServiceMessageApplication }> } };

export type ServiceMessageDetailsFragment = { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, unPublishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, location?: Array<Types.ServiceMessageLocation>, application?: Types.ServiceMessageApplication };

export type SingleServiceMessageQueryVariables = Types.Exact<{
  serviceMessageId: Types.Scalars['String']['input'];
}>;


export type SingleServiceMessageQuery = { singleServiceMessage?: { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, unPublishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, location?: Array<Types.ServiceMessageLocation>, application?: Types.ServiceMessageApplication } };

export type DeleteServiceMessageMutationVariables = Types.Exact<{
  serviceMessageId: Types.Scalars['String']['input'];
}>;


export type DeleteServiceMessageMutation = { deleteServiceMessage?: { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, unPublishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, location?: Array<Types.ServiceMessageLocation>, application?: Types.ServiceMessageApplication } };

export type UpsertServiceMessageMutationVariables = Types.Exact<{
  serviceMessage: Types.ServiceMessageInput;
}>;


export type UpsertServiceMessageMutation = { upsertServiceMessage?: { id?: string, title?: string, content?: string, published: boolean, publishDate?: string, unPublishDate?: string, segmentIn?: Array<string>, segmentNotIn?: Array<string>, location?: Array<Types.ServiceMessageLocation>, application?: Types.ServiceMessageApplication } };

export const ServiceMessageDetailsFragmentDoc = gql`
    fragment ServiceMessageDetails on ServiceMessage {
  id
  title
  content
  published
  publishDate
  unPublishDate
  segmentIn
  segmentNotIn
  location
  application
}
    `;
export const ServiceMessagesDocument = gql`
    query ServiceMessages {
  paginateServiceMessages {
    total
    items {
      ...ServiceMessageDetails
    }
  }
}
    ${ServiceMessageDetailsFragmentDoc}`;

/**
 * __useServiceMessagesQuery__
 *
 * To run a query within a React component, call `useServiceMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServiceMessagesQuery, ServiceMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServiceMessagesQuery, ServiceMessagesQueryVariables>(ServiceMessagesDocument, options);
      }
export function useServiceMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceMessagesQuery, ServiceMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServiceMessagesQuery, ServiceMessagesQueryVariables>(ServiceMessagesDocument, options);
        }
// @ts-ignore
export function useServiceMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServiceMessagesQuery, ServiceMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServiceMessagesQuery, ServiceMessagesQueryVariables>;
export function useServiceMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServiceMessagesQuery, ServiceMessagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServiceMessagesQuery | undefined, ServiceMessagesQueryVariables>;
export function useServiceMessagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServiceMessagesQuery, ServiceMessagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServiceMessagesQuery, ServiceMessagesQueryVariables>(ServiceMessagesDocument, options);
        }
export type ServiceMessagesQueryHookResult = ReturnType<typeof useServiceMessagesQuery>;
export type ServiceMessagesLazyQueryHookResult = ReturnType<typeof useServiceMessagesLazyQuery>;
export type ServiceMessagesSuspenseQueryHookResult = ReturnType<typeof useServiceMessagesSuspenseQuery>;
export type ServiceMessagesQueryResult = ApolloReactCommon.QueryResult<ServiceMessagesQuery, ServiceMessagesQueryVariables>;
export const SingleServiceMessageDocument = gql`
    query SingleServiceMessage($serviceMessageId: String!) {
  singleServiceMessage(serviceMessageId: $serviceMessageId) {
    ...ServiceMessageDetails
  }
}
    ${ServiceMessageDetailsFragmentDoc}`;

/**
 * __useSingleServiceMessageQuery__
 *
 * To run a query within a React component, call `useSingleServiceMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleServiceMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleServiceMessageQuery({
 *   variables: {
 *      serviceMessageId: // value for 'serviceMessageId'
 *   },
 * });
 */
export function useSingleServiceMessageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleServiceMessageQuery, SingleServiceMessageQueryVariables> & ({ variables: SingleServiceMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>(SingleServiceMessageDocument, options);
      }
export function useSingleServiceMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>(SingleServiceMessageDocument, options);
        }
// @ts-ignore
export function useSingleServiceMessageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>;
export function useSingleServiceMessageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleServiceMessageQuery | undefined, SingleServiceMessageQueryVariables>;
export function useSingleServiceMessageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>(SingleServiceMessageDocument, options);
        }
export type SingleServiceMessageQueryHookResult = ReturnType<typeof useSingleServiceMessageQuery>;
export type SingleServiceMessageLazyQueryHookResult = ReturnType<typeof useSingleServiceMessageLazyQuery>;
export type SingleServiceMessageSuspenseQueryHookResult = ReturnType<typeof useSingleServiceMessageSuspenseQuery>;
export type SingleServiceMessageQueryResult = ApolloReactCommon.QueryResult<SingleServiceMessageQuery, SingleServiceMessageQueryVariables>;
export const DeleteServiceMessageDocument = gql`
    mutation DeleteServiceMessage($serviceMessageId: String!) {
  deleteServiceMessage(serviceMessageId: $serviceMessageId) {
    ...ServiceMessageDetails
  }
}
    ${ServiceMessageDetailsFragmentDoc}`;
export type DeleteServiceMessageMutationFn = ApolloReactCommon.MutationFunction<DeleteServiceMessageMutation, DeleteServiceMessageMutationVariables>;

/**
 * __useDeleteServiceMessageMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMessageMutation, { data, loading, error }] = useDeleteServiceMessageMutation({
 *   variables: {
 *      serviceMessageId: // value for 'serviceMessageId'
 *   },
 * });
 */
export function useDeleteServiceMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteServiceMessageMutation, DeleteServiceMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteServiceMessageMutation, DeleteServiceMessageMutationVariables>(DeleteServiceMessageDocument, options);
      }
export type DeleteServiceMessageMutationHookResult = ReturnType<typeof useDeleteServiceMessageMutation>;
export type DeleteServiceMessageMutationResult = ApolloReactCommon.MutationResult<DeleteServiceMessageMutation>;
export type DeleteServiceMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteServiceMessageMutation, DeleteServiceMessageMutationVariables>;
export const UpsertServiceMessageDocument = gql`
    mutation UpsertServiceMessage($serviceMessage: ServiceMessageInput!) {
  upsertServiceMessage(serviceMessage: $serviceMessage) {
    ...ServiceMessageDetails
  }
}
    ${ServiceMessageDetailsFragmentDoc}`;
export type UpsertServiceMessageMutationFn = ApolloReactCommon.MutationFunction<UpsertServiceMessageMutation, UpsertServiceMessageMutationVariables>;

/**
 * __useUpsertServiceMessageMutation__
 *
 * To run a mutation, you first call `useUpsertServiceMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertServiceMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertServiceMessageMutation, { data, loading, error }] = useUpsertServiceMessageMutation({
 *   variables: {
 *      serviceMessage: // value for 'serviceMessage'
 *   },
 * });
 */
export function useUpsertServiceMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertServiceMessageMutation, UpsertServiceMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertServiceMessageMutation, UpsertServiceMessageMutationVariables>(UpsertServiceMessageDocument, options);
      }
export type UpsertServiceMessageMutationHookResult = ReturnType<typeof useUpsertServiceMessageMutation>;
export type UpsertServiceMessageMutationResult = ApolloReactCommon.MutationResult<UpsertServiceMessageMutation>;
export type UpsertServiceMessageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertServiceMessageMutation, UpsertServiceMessageMutationVariables>;